"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputStyles = exports.Wrapper = exports.StyledInput = exports.StyledIcon = exports.StyledClearIcon = exports.StyledButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../../Icon"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var inputStyles = /*#__PURE__*/(0, _styledComponents.css)(["display:block;width:100%;padding:", ";padding-left:", ";padding-right:", ";border:1px solid ", ";margin-top:", ";outline:none;font-size:", ";font-family:'Source Sans Pro',sans-serif;line-height:", ";color:", ";background-color:", ";::placeholder,::-webkit-input-placeholder,:-ms-input-placeholder{color:", ";}::-webkit-calendar-picker-indicator{cursor:pointer;filter:", ";}&:focus,&.invalid{padding:calc(", " - 1px);padding-left:calc(", " - 1px);padding-right:", ";border:2px solid ", ";}&.invalid{border:2px solid ", ";}", " ", ""], function (p) {
  return p.theme.tokens.spacing04;
}, function (p) {
  return p.icon && p.theme.tokens.spacing08;
}, function (p) {
  return p.handleClear && p.theme.tokens.spacing08;
}, function (p) {
  return p.theme.colorBorderInput;
}, function (p) {
  return p.theme.tokens.spacing01;
}, function (p) {
  return p.theme.tokens.fontSizeMedium;
}, function (p) {
  return p.theme.tokens.lineHeightText;
}, function (p) {
  return p.theme.colorTextInputLabel;
}, function (p) {
  return p.theme.colorBackgroundInput;
}, function (p) {
  return p.theme.colorTextInputPlaceholder;
}, function (p) {
  return p.theme.name === 'default' ? 'invert(0.25)' : 'invert(0.8)';
}, function (p) {
  return p.theme.tokens.spacing04;
}, function (p) {
  return p.icon && p.theme.tokens.spacing08;
}, function (p) {
  return p.handleClear && p.theme.tokens.spacing08;
}, function (p) {
  return p.theme.colorBorderInputFocus;
}, function (p) {
  return p.theme.colorBorderInputError;
}, function (p) {
  return p.disabled ? (0, _styledComponents.css)(["background-color:", ";border-color:", ";cursor:not-allowed;color:", ";"], function (p) {
    return p.theme.colorBackgroundInputDisabled;
  }, function (p) {
    return p.theme.colorBorderInputDisabled;
  }, function (p) {
    return p.theme.colorTextInputDisabled;
  }) : null;
}, function (p) {
  var width;

  switch (p.size) {
    case 'xs':
      width = '5rem';
      break;

    case 's':
      width = '10rem';
      break;

    case 'm':
      width = '20rem';
      break;

    case 'l':
      width = '30rem';
      break;

    case 'xl':
      width = '46rem';
      break;

    default:
      console.warn("invalid size '".concat(p.size, "' provided. the supported values are xs, s, m, l and xl"));
  }

  return (0, _styledComponents.css)(["width:", ";"], width);
});
exports.inputStyles = inputStyles;

var StyledInput = /*#__PURE__*/_styledComponents["default"].input.withConfig({
  displayName: "indexstyles__StyledInput",
  componentId: "sc-y29rr8-0"
})(["", ""], inputStyles);

exports.StyledInput = StyledInput;

var Wrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__Wrapper",
  componentId: "sc-y29rr8-1"
})(["position:relative;"]);

exports.Wrapper = Wrapper;
var StyledIcon = /*#__PURE__*/(0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "indexstyles__StyledIcon",
  componentId: "sc-y29rr8-2"
})(["position:absolute;fill:", ";margin:auto 0 auto ", ";cursor:text;height:100%;"], function (p) {
  return p.theme.colorIconInput;
}, function (p) {
  return p.theme.tokens.spacing04;
});
exports.StyledIcon = StyledIcon;

var StyledButton = /*#__PURE__*/_styledComponents["default"].button.withConfig({
  displayName: "indexstyles__StyledButton",
  componentId: "sc-y29rr8-3"
})(["background:none;border:none;bottom:2px;cursor:pointer;padding:0 ", " 0;position:absolute;right:2px;top:2px;"], function (p) {
  return p.theme.tokens.spacing04;
});

exports.StyledButton = StyledButton;

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "currentcolor"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
  }));
};

var StyledClearIcon = /*#__PURE__*/(0, _styledComponents["default"])(CloseIcon).withConfig({
  displayName: "indexstyles__StyledClearIcon",
  componentId: "sc-y29rr8-4"
})(["fill:", ";"], function (p) {
  return p.theme.colorIconInput;
});
exports.StyledClearIcon = StyledClearIcon;